<template>
  <div class="hpanel contact-panel" v-if="project">
    <div class="panel-heading ">
      <span v-if="project.shared_with.length !== 0" class="label label-success">Shared</span>
      <span v-if="project.question !== null" class="label label-info" style="margin-right: 5px">
          {{project.question.status.name}}
      </span>
      <router-link :to="{name: 'ProjectDetails', params: {id: project.id}}"  :title="project.name" >{{project.name|truncate(37)}}
      </router-link>
      <div class="panel-tools">
        <div class="btn-group">
          <router-link class="btn btn-xs btn-info" id="open_project" title="Open"
                       :to="{name: 'ProjectDetails', params: {id: project.id}}"><i class="fa fa-eye"></i> <span class="hidden-xs hidden-md">Open</span>
          </router-link>
          <button class="btn btn-xs btn-info btn-outline" title="Edit"
                  @click="modalAction = 'edit'"><i class="fas fa-pencil-alt"></i> <span class="hidden-xs hidden-md">Edit</span>
          </button>
          <button class="btn btn-xs btn-info btn-outline"
                  v-if="$auth.user().id === project.owner_id" title="Share"
                  @click="modalAction = 'share'"><i class="fa fa-share-alt"></i> <span class="hidden-xs hidden-md hidden-lg">Share</span>
          </button>
          <button class="btn btn-xs btn-info btn-outline"
                  v-if="$auth.user().id === project.owner_id || isShared" title="Duplicate"
                  @click="modalAction = 'duplicate'"><i class="fa fa-clone"></i> <span class="hidden-xs hidden-md hidden-lg">Duplicate</span>
          </button>
          <button class="btn btn-xs btn-danger btn-outline" title="remove"
                  v-if="$auth.user().id === project.owner_id"
                  @click="modalAction = 'delete'"><i class="fa fa-remove"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="panel-body">
      <div v-if="project.description" v-html="project.description" style="max-height: 100px; overflow: auto">
      </div>
      <p v-else style="font-style: italic">
        Brief project description...
      </p>
    </div>
    <div class="panel-footer contact-footer" >
      <div class="row">

        <template v-if="project.workflow_id === 1">
          <div :class="$auth.user().id === project.owner_id ? 'col-xs-12' : 'col-xs-6'">
            <div class="contact-stat">
              <span>Subproject(s): </span>
              <strong>{{project.lists.length}}</strong>
            </div>
          </div>
          <template v-if="project.owner && $auth.user().id !== project.owner_id">
            <div class="col-xs-6">
              <div class="contact-stat border-left">
                <span>Owner: </span>
                <strong v-if="project.owner && $auth.user().id !== project.owner_id">{{project.owner.lastname}}
                  {{project.owner.firstname}}</strong>
                <strong v-else>You</strong>
              </div>
            </div>
          </template>

        </template>
        <template v-else>
          <div :class="$auth.user().id === project.owner_id ? 'col-xs-4' : 'col-xs-3'">
            <div class="contact-stat border-right">
              <span>Subproject(s) </span>
              <strong>{{project.lists.length}}</strong>
            </div>
          </div>
          <div :class="$auth.user().id === project.owner_id ? 'col-xs-4' : 'col-xs-3'">
            <div class="contact-stat border-right">
              <span>Mailing(s) </span>
              <strong v-if="project.question && project.question.mailing">{{project.question.mailing.length}}</strong>
              <strong v-else>0</strong>
            </div>
          </div>
          <template v-if="project.owner && $auth.user().id !== project.owner_id">
            <div class="col-xs-3">
              <div class="contact-stat border-right">
                <span>Owner: </span>
                <strong v-if="project.owner && $auth.user().id !== project.owner_id">{{project.owner.lastname}}
                  {{project.owner.firstname}}</strong>
                <strong v-else>You</strong>
              </div>
            </div>
          </template>

          <div :class="$auth.user().id === project.owner_id ? 'col-xs-4' : 'col-xs-3'">
            <div class="contact-stat">
              <span>Broker: </span>
              <div v-if="project.question && project.question.consultant">
                <strong>{{project.question.consultant.firstname}} {{project.question.consultant.lastname}}</strong>
              </div>
              <div v-else><strong> Not defined </strong></div>
            </div>
          </div>
        </template>

      </div>
      <div class="row text-italic">
        <dfn>
          <div class="col-md-6 col-xs-6 "><strong><span>Workflow: </span></strong>{{project.workflow.name}}</div>
          <div class="col-md-6 col-xs-6 text-right"><strong><span>Updated: </span></strong> {{project.updated_at | moment('LL')}}</div>
        </dfn>
      </div>
    </div>
    <template v-if="modalAction !== null">
      <action-modal-project :project="project" v-model="modalAction" :refresh="refresh"/>
    </template>
  </div>
</template>

<style scoped>
  body.light-skin .hpanel.panel-collapse .panel-heading {
    -webkit-box-shadow: unset;
    box-shadow: none;
  }

  .hpanel.collapsed .panel-body, .hpanel.collapsed .panel-footer {
    display: block;
  }

  body.light-skin .hpanel .panel-heading {
    /*border-top: 1px solid #eaeaea !important;*/
  }

  /*body.light-skin .hpanel .panel-body {*/
  /*border-top: 1px solid #eaeaea !important;*/

  /*}*/

  .panel-tools a {
    color: white;
  }

</style>

<script>
import ActionModalProject from './ActionModalProject'

export default {
  components: {
    ActionModalProject
  },
  props: ['project', 'portfolio'],
  name: 'ProjectItem',
  computed: {
    isShared: function () {
      let isShared = false

      if (this.project !== 'undefined') {
        isShared = this.project.shared_with.find((user) => {
          return this.$auth.user().id === user.id
        })
      }
      return isShared !== 'undefined'
    }

  },
  data () {
    return {
      modalAction: null
    }
  },
  methods: {
    refresh: function (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/project/ProjectItem.vue